// ── Registro de manuales del Centro de ayuda ─────────────────────────────────
// Para añadir un manual nuevo: colocar el/los PDF en frontend/public/manuales/,
// añadir una entrada aquí y sus claves i18n (help.manuals.<id>.title/desc).
// Si no existe versión en un idioma, se sirve la española (fallback).

export type ManualIcon = 'sequence' | 'datasheet' | 'week' | 'report'
export type ManualLang = 'es' | 'en'

export interface ManualFile {
  /** Ruta pública servida por el frontend (vite public/ → raíz del sitio) */
  file: string
  /** Nombre de archivo sugerido al descargar */
  fileName: string
  sizeLabel: string
}

export interface ManualEntry {
  id: string
  titleKey: string
  descKey: string
  icon: ManualIcon
  files: { es: ManualFile } & Partial<Record<ManualLang, ManualFile>>
}

export const MANUALS: ManualEntry[] = [
  {
    id: 'secuencia-produccion',
    titleKey: 'help.manuals.secuencia.title',
    descKey: 'help.manuals.secuencia.desc',
    icon: 'sequence',
    files: {
      es: {
        file: '/manuales/manual-secuencia-produccion-es.pdf',
        fileName: 'Manual - Secuencia de Produccion.pdf',
        sizeLabel: '620 KB',
      },
      en: {
        file: '/manuales/manual-secuencia-produccion-en.pdf',
        fileName: 'Manual - Production Sequence.pdf',
        sizeLabel: '620 KB',
      },
    },
  },
  {
    id: 'gantt',
    titleKey: 'help.manuals.gantt.title',
    descKey: 'help.manuals.gantt.desc',
    icon: 'week',
    files: {
      es: {
        file: '/manuales/manual-gantt-es.pdf',
        fileName: 'Manual - Gantt de Produccion.pdf',
        sizeLabel: '1 MB',
      },
      en: {
        file: '/manuales/manual-gantt-en.pdf',
        fileName: 'Manual - Production Gantt.pdf',
        sizeLabel: '1 MB',
      },
    },
  },
  {
    id: 'reports',
    titleKey: 'help.manuals.reports.title',
    descKey: 'help.manuals.reports.desc',
    icon: 'report',
    files: {
      es: {
        file: '/manuales/manual-reports-es.pdf',
        fileName: 'Manual - Informes de cliente.pdf',
        sizeLabel: '2,2 MB',
      },
      en: {
        file: '/manuales/manual-reports-en.pdf',
        fileName: 'Manual - Customer Reports.pdf',
        sizeLabel: '2,2 MB',
      },
    },
  },
  {
    id: 'ficha-tecnica',
    titleKey: 'help.manuals.fichaTecnica.title',
    descKey: 'help.manuals.fichaTecnica.desc',
    icon: 'datasheet',
    files: {
      es: {
        file: '/manuales/manual-ficha-tecnica.pdf',
        fileName: 'Manual - Ficha Tecnica.pdf',
        sizeLabel: '1.5 MB',
      },
    },
  },
]
